import React from "react"
import { useLocation } from "react-router-dom"

import Header from "../screens/Header"

const Layout = ({ children }) => {
  const location = useLocation()

  const noHeaderPrefixes = ["/projects"]

  const shouldShowHeader = !noHeaderPrefixes.some((prefix) =>
    location.pathname.startsWith(prefix),
  )

  return (
    <>
      {shouldShowHeader && <Header />}
      {children}
    </>
  )
}

export default Layout
